import { signOut } from 'firebase/auth';

import { ThunkType } from 'store/types';
import { firebaseAuth } from 'config/firebase';

import { setCurrentUser } from './slice';

export const logoutThunk = (): ThunkType<Promise<void>> => async (dispatch) => {
  try {
    const auth = firebaseAuth;

    if (auth.currentUser) {
      await signOut(firebaseAuth);
    }
  } catch (error) {
    return Promise.reject(error);
  } finally {
    dispatch(setCurrentUser(undefined));
  }
};
